import { render, staticRenderFns } from "./AnswerOptions.vue?vue&type=template&id=0f1c59cd&scoped=true"
import script from "./AnswerOptions.vue?vue&type=script&lang=js"
export * from "./AnswerOptions.vue?vue&type=script&lang=js"
import style0 from "./AnswerOptions.vue?vue&type=style&index=0&id=0f1c59cd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c59cd",
  null
  
)

export default component.exports